/**
 * 「내 화면」(워크스페이스 `menuSets` 의 줄로 여는 화면)을 화면에 낼지 — **스위치 하나**. 지금은 가려 둔다(보류).
 *
 * 끄면 함께 사라진다:
 * ① 추적 관리의 「내 화면」 구역 · 세트 줄 ⋯ 의 「이 세트로 화면 만들기」
 * ② 화면 만들기(`/service/view-new`) — 추적 관리로 보낸다
 * ③ 브랜드 멘션의 `?view=<줄>` — 줄을 펴지 않고 기본 브랜드 멘션으로 연다(대시보드 편집 단추도 안 선다)
 * ④ 대시보드 꾸미기(`/service/tracking/brand-mentions/edit`) — 브랜드 멘션으로 보낸다
 *
 * 🔑 저장본과 코드는 그대로 둔다 — `true` 로 두면 전부 다시 선다. 사이드바는 원래 사용자 줄을 세우지 않는다.
 * ⚠️ 브랜드 멘션·타겟 키워드의 「필터 저장」은 이 스위치와 무관하다 — 기본 필터를 적는 일이다.
 */
export const MY_SCREENS_VISIBLE: boolean = false;
